import {useCallback} from 'react';
import {useLocation} from 'react-router-dom';

const useQuery = () => {
  const {search} = useLocation();
  const query = new URLSearchParams(search);

  const getAll = useCallback(() => {
    const keys = query.keys();
    let queryValues = {};

    for (const key of keys) {
      queryValues = {...queryValues, [key]: query.get(key)};
    }

    return queryValues;
  }, [query]);

  return getAll() as any;
};

export default useQuery;
